<template>
  <div class="download-report-screen">
    <CamsButton priority="primary" type="button" @click="selectFormat('xlsx')">
      {{ $t('downloadReportXLSX') }}
    </CamsButton>
    <CamsButton type="button" @click="selectFormat('csv')">
      {{ $t('downloadReportCSV') }}
    </CamsButton>
  </div>
</template>

<script>
import {methodsForDialogMixin} from "@/components/pacs/mixins.js";

export default {
  name: "DownloadReportScreen",
  mixins: [methodsForDialogMixin],
  methods: {
    selectFormat(format) {
      this.closeDialog(format);
    },
  },
};
</script>

<style scoped lang="scss">
.download-report-screen {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
</style>
